import { Dialog, Typography } from "@mui/material";
import { LineChart } from "@mui/x-charts";
import { useEffect, useState } from "react";
import { dataset } from "../historydataset";

type historyTypes = { open: boolean; handleClose: () => void };

type HistoryEntry = {
  timestamp: string;
  total: number;
  available: number;
  inUse: number;
  damaged: number;
};

type HistoryData = {
  history: HistoryEntry[];
};

const KeyNumberHistory: React.FC<historyTypes> = ({ open, handleClose }) => {
  const [historyData, sethistoryData] = useState<HistoryData | null>(null);
  const [historyDates, sethistoryDates] = useState();
  const [historyTotal, sethistoryTotal] = useState();

  const getData = async (): Promise<void> => {
    try {
      const res = await fetch("/historymockdata.json");
      if (!res.ok) {
        throw new Error(`Response status: ${res.status}`);
      }
      const data = await res.json();
      sethistoryData(data);
      sethistoryDates(data.history.map((item: HistoryEntry) => item.timestamp));
      sethistoryTotal(data.history.map((item: HistoryEntry) => item.total));
      console.log(data.history.map((item: HistoryEntry) => item.timestamp));
    } catch (error) {
      if (error instanceof Error) {
        console.log(error.message);
      } else {
        console.log("Unknown error", error);
      }
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const xAxisFormatter = (date: any) => {
    const dayName = date.toLocaleDateString("da-DK", { weekday: "short" });
    const day = date.getDate();
    const monthName = date.toLocaleDateString("da-DK", { month: "long" });
    const year = date.getFullYear();

    const time = date.toLocaleDateString("da-DK", { hour12: false });
    return `${dayName} d. ${day} ${monthName} ${year} ${time}`
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <LineChart
        dataset={dataset}
        xAxis={[
          {
            id: "Years",
            dataKey: "date",
            scaleType: "time",
            valueFormatter: xAxisFormatter,
          },
        ]}
        series={[
          {
            id: "Total",
            label: "Total Items",
            dataKey: "total",
          },
        ]}
        height={600}
        width={600}
      />
    </Dialog>
  );
};

export default KeyNumberHistory;
